/* ----------- RESOURCES ----------- */
import { useState } from "react";
import { toast } from "react-toastify";

import companyService from "services/companyService";
import establishmentService from "services/establishmentService";
import ImageIconImport from 'assets/icons/import.svg'
import ImageIconEye from 'assets/icons/eye-open.svg'

/* ----------- COMPONENTS ----------- */
import Actions from "components/admin/Actions";
import ButtonIcon from "components/ButtonIcon";
import UploadFile from "components/admin/UploadFile";
import InfoTableModal from "components/admin/InfoTableModal";
import { Form, Card, Col, Modal, Button } from "react-bootstrap";

/* ----------- STYLES ----------- */
import styles from "pages/admin/import/styles.module.scss";

export default function Import() {
    const [fileCompany, setFileCompany] = useState<File | null>(null);
    const [fileAccreditedNetwork, setFileAccreditedNetwork] = useState<File | null>(null);

    const [isSubmit, setIsSubmit] = useState({
        file1: false,
        file2: false,
    });

    const breadcrumbs = [
        {
            label: "Início",
            path: "/admin/home",
        },
        {
            label: "Importações",
            path: "/admin/importacoes",
        },
    ];

    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);

    const columnsImport1 = ["Identificador", "Campo", "Descrição", "Exemplo"];

    const rowsImport1 = [
      ["telenet_id", "ID da Telenet", "Identificador único da empresa no sistema externo.", "000000"],
      ["name", "Nome da empresa", "Nome da empresa para cadastro ou atualização.", "Tech Soluções LTDA"],
      ["cnpj", "CNPJ", "Número de identificação legal da empresa.", "12.345.678/0001-99"],
      ["email", "E-mail", "E-mail de contato e login do usuário associado à empresa.", "contato@empresa.com"],
    ];

    const columnsImport2 = ["Identificador", "Campo", "Descrição", "Exemplo"];

    const rowsImport2 = [
      ["telenet_id", "ID da Telenet", "Identificador único do estabelecimento no sistema externo.", "000000"],
      ["state", "Estado", "Sigla do estado (UF) do estabelecimento.", "SP"],
      ["city", "Cidade", "Nome da cidade do estabelecimento.", "São Paulo"],      
      ["neighborhood", "Bairro", "Bairro onde o estabelecimento está localizado.", "Centro"],
      ["name", "Nome do estabelecimento", "Nome do estabelecimento para cadastro ou atualização.", "Padaria Central"],
      ["cnpj", "CNPJ", "Número de identificação legal do estabelecimento.", "12.345.678/0001-99"],
      ["address", "Endereço", "Logradouro principal do estabelecimento.", "Rua das Flores"],
      ["complement", "Complemento", "Informações adicionais sobre o endereço (ex: sala, bloco).", "Bloco A, sala 5"],
    ];

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    function handleChangeFileClient(files) {
        if (!files) return;

        setFileCompany(files[0]);
    }

    function handleChangeFileAccreditedNetwork(files) {
        if (!files) return;

        setFileAccreditedNetwork(files[0]);
    }

    function handleImport() {
        if (fileCompany) {
            const formData = new FormData();
            formData.append("file_companies", fileCompany);

            setIsSubmit((t) => ({ ...t, file1: true }));

            companyService
                .import(formData)
                .then(() => toast.success("Dados dos clientes importado", { autoClose: 3000 }))
                .catch((err) => {
                    if (err.status === 400) {
                        return toast.error("O formato dos dados são válidos", { autoClose: 3000 });
                    }

                    toast.error("Ocorreu um erro ao importar os dados dos clientes", { autoClose: 3000 });
                })
                .finally(() => setIsSubmit((t) => ({ ...t, file1: false })));
        }

        if (fileAccreditedNetwork) {
            const formData = new FormData();
            formData.append("file_establishments", fileAccreditedNetwork);

            setIsSubmit((t) => ({ ...t, file2: true }));

            establishmentService
                .import(formData)
                .then(() => toast.success("Dados dos credenciados importados"))
                .catch((err) => {
                    if (err.status === 400) {
                        return toast.error("O formato dos dados são válidos", { autoClose: 3000 });
                    }

                    toast.error("Ocorreu um erro ao importar os dados dos credenciados", { autoClose: 3000 });
                })
                .finally(() => setIsSubmit((t) => ({ ...t, file2: false })));
        }
    }

    function generateFilename (baseName: string) {
        const pad = (v: number) => String(v).padStart(2, "0");
        const now = new Date();
        const dd = pad(now.getDate());
        const mm = pad(now.getMonth() + 1);
        const yyyy = now.getFullYear();
        const hh = pad(now.getHours());
        const min = pad(now.getMinutes());
        const ss = pad(now.getSeconds());
        return `${baseName}_${dd}${mm}${yyyy}_${hh}${min}${ss}.xls`;
    }

    return (
        <>
<Actions
  breadcrumb={breadcrumbs}
  title="Importações"
  actionButtons={
    <>
      <Col className="col-auto col-lg-3 d-grid">
        <ButtonIcon
          icon={isSubmit.file1 || isSubmit.file2 ? "loading" : "news-navbar"}
          disabled={
            (!fileCompany && !fileAccreditedNetwork) ||
            isSubmit.file1 ||
            isSubmit.file2
          }
          onClick={() => setShowConfirmModal(true)}
        >
          {isSubmit.file1 || isSubmit.file2 ? "Importando" : "Importar"}
        </ButtonIcon>
      </Col>
    </>
  }
/>


            <h3 className={styles.form_title}>Clientes (Brasil Convênios)</h3>

            <div className={`${styles.container_card_import} justify-content-between `}>
                <div className="col-12 col-xl-6 col-xxl-4 mb-4 pe-xl-2">


                <Card className={`${styles.form_card}`}>
                    <Card.Body className={styles.card_body_centered_btn}>
                        <Form onSubmit={(e) => e.preventDefault()}>
                            <Form.Group>
                                <UploadFile
                                    label="Selecionar arquivo de clientes para importação (formato da planilha obrigatoriamente padrão)"
                                    accept="text/csv, application/vnd.ms-excel, application/vnd.oasis.opendocument.spreadsheet"
                                    labelAccept="CSV, XLS, ODS"
                                    inputFileState={fileCompany}
                                    onChange={handleChangeFileClient}
                                    onRemoveFile={() => setFileCompany(null)}
                                    classNameForm={`${styles.upload_custom}`}
                                />
                            </Form.Group>
                        </Form>

                        <div className="mt-3 d-flex justify-content-center align-items-center gap-3">
                          <a
                            href="/templates/planilha_importacao_clientes.xls"
                            className={`${styles.btn_style_import} btn btn-link p-0 d-flex align-items-center gap-1 `}
                            download
                            onClick={(e) => {
                              const link = e.currentTarget as HTMLAnchorElement;
                              link.download = generateFilename("planilha_importacao_clientes");
                            }}
                          >
                            Modelo de planilha (.xls)
                            <img
                              src={ImageIconImport}
                              alt=""
                              width={16}
                              height={16}
                            />
                          </a>

                          <button
                            type="button"
                            className={`${styles.btn_style_import} btn btn-link p-0 d-flex align-items-center gap-1 `}
                            onClick={() => setShowModal1(true)}
                          >
                            Guia de preenchimento
                            <img
                              src={ImageIconEye}
                              alt=""
                              width={16}
                              height={16}
                            />
                          </button>
                        </div>

                        <InfoTableModal
                          show={showModal1}
                          onHide={() => setShowModal1(false)}
                          title="Guia de preenchimento da planilha de clientes"
                          description="Ao executar esta importação no sistema, um novo registro é criado ou um existente é atualizado na tabela companies, conforme o caso. Ao mesmo tempo, um novo registro é gerado na tabela users, que é vinculado à empresa criada ou atualizada, permitindo assim que o usuário correspondente acesse o sistema."
                          columns={columnsImport1}
                          rows={rowsImport1}
                        />


                    </Card.Body>
                </Card>
                </div>

                <div className="col-12 col-xl-6 col-xxl-8 mb-4 ps-xl-2">

                <Card className={`${styles.form_card}`}>
                    <Card.Body className={styles.card_body_centered}>
                         <h5 className={styles.h5_info}>Detalhes da importação de clientes (Brasil Convênios)</h5>

                        <p className={styles.text_info}>
                            Ao importar os dados, cada cliente terá acesso ao sistema por meio da seguinte URL:
                            <strong> https://admin.brasilconvenios.com.br</strong>.
                        </p>

                        <p className={styles.text_info}>
                            O <strong>usuário</strong> será o <strong>e-mail</strong> informado no arquivo, e a <strong>senha inicial</strong> será composta pelo padrão:  
                            <strong className={styles.info_password}>CÓDIGO@CNPJ/CPF</strong>
                        </p>

                        <p className={styles.text_info}>
                            Exemplo: <strong>28295@23467809822</strong>
                        </p>

                        <p className={styles.text_info}>
                            Se o cliente já estiver cadastrado no sistema (com base no <strong>telenet_id</strong> ou <strong>e-mail</strong>), suas informações serão <strong>atualizadas automaticamente</strong>.
                            Caso contrário, um novo cadastro será criado.
                        </p>
                        <p className={styles.text_info}>
                            <strong>Atenção:</strong> O ordenamento das colunas deve seguir exatamente o modelo fornecido para garantir o correto processamento dos dados.
                        </p>                           
                    </Card.Body>
                </Card>

                </div>
 </div> 
         

            <h3 className={styles.form_title}>Rede Credenciada</h3>


            <div className={`${styles.container_card_import} justify-content-between `}>
                <div className="col-12 col-xl-6 col-xxl-4 mb-4 pe-xl-2">
                    <Card className={`${styles.form_card}`}>
                        <Card.Body className={styles.card_body_centered_btn}>
                            <Form onSubmit={(e) => e.preventDefault()}>
                                <Form.Group>
                                    <UploadFile
                                        label="Selecionar arquivo de credenciados para importação (formato da planilha obrigatoriamente padrão)"
                                        accept="text/csv, application/vnd.ms-excel, application/vnd.oasis.opendocument.spreadsheet"
                                        labelAccept="CSV, XLS, ODS"
                                        inputFileState={fileAccreditedNetwork}
                                        onChange={handleChangeFileAccreditedNetwork}
                                        onRemoveFile={() => setFileAccreditedNetwork(null)}
                                        classNameForm={`${styles.upload_custom}`}                                        
                                    />
                                </Form.Group>
                            </Form>





                        <div className="mt-3 d-flex justify-content-center align-items-center gap-3">
                          <a
                            href="/templates/planilha_importacao_credenciados.xls"
                            className={`${styles.btn_style_import} btn btn-link p-0 d-flex align-items-center gap-1 `}
                            download
                            onClick={(e) => {
                              const link = e.currentTarget as HTMLAnchorElement;
                              link.download = generateFilename("planilha_importacao_credenciados");
                            }}
                          >
                            Modelo de planilha (.xls)
                            <img
                              src={ImageIconImport}
                              alt=""
                              width={16}
                              height={16}
                            />
                          </a>

                          <button
                            type="button"
                            className={`${styles.btn_style_import} btn btn-link p-0 d-flex align-items-center gap-1 `}
                            onClick={() => setShowModal2(true)}
                          >
                            Guia de preenchimento
                            <img
                              src={ImageIconEye}
                              alt=""
                              width={16}
                              height={16}
                            />
                          </button>
                        </div>

                        <InfoTableModal
                          show={showModal2}
                          onHide={() => setShowModal2(false)}
                          title="Guia de preenchimento da planilha de credenciados"
                          description="Esta importação tem como objetivo criar novos registros ou atualizar os existentes na tabela establishments. Isso garante que as informações do estabelecimento sejam atualizadas e sincronizadas com os dados fornecidos no arquivo importado."
                          columns={columnsImport2}
                          rows={rowsImport2}
                        />










                        </Card.Body>
                    </Card>
                </div>
                <div className="col-12 col-xl-6 col-xxl-8 mb-4 ps-xl-2">
                    <Card className={`${styles.form_card}`}>
                        <Card.Body className={styles.card_body_centered}>
                            <h5 className={styles.h5_info}>Detalhes da importação de credenciados</h5>
                            <p className={styles.text_info}>
                                Ao importar o arquivo, o sistema verifica se o credenciado já está cadastrado com base no campo <strong>telenet_id</strong>.
                            </p>
                            <p className={styles.text_info}>
                                Se o credenciado já existir, suas informações serão <strong>atualizadas automaticamente</strong> com os novos dados do arquivo.
                            </p>
                            <p className={styles.text_info}>
                                Se não existir, um <strong>novo credenciado será criado</strong> com as informações fornecidas.
                            </p>
                            <p className={styles.text_info}>
                                <strong>Atenção:</strong> O ordenamento das colunas deve seguir exatamente o modelo fornecido para garantir o correto processamento dos dados.
                            </p>                                                                   
                        </Card.Body>
                    </Card>
                </div>
             </div>


            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered className={`${styles.modal}`}>
              <Modal.Header closeButton className={styles.modal_header} >
                <Modal.Title>Confirmação de Importação</Modal.Title>
              </Modal.Header>
              <Modal.Body  className={`${styles.modal_body}`} >
                <strong>Advertência:</strong> Esta ação importará os arquivos selecionados para o sistema.  
                Certifique-se de que os dados estão corretos, pois a importação poderá sobrescrever informações existentes.  
                <br /><br />
                Recomendamos fortemente que você verifique a integridade das informações antes de continuar.  
                <br /><br />
                Tem certeza de que deseja prosseguir com a importação?
              </Modal.Body>
              <Modal.Footer className={`${styles.modal_footer}`}>
                <Button variant="light" onClick={() => setShowConfirmModal(false)} className={`${styles.modal_buttons}`}>
                  Cancelar
                </Button>
                <Button
                    className={`${styles.modal_buttons_ok}`}
                  variant="dark"
                  onClick={() => {
                    setShowConfirmModal(false);
                    handleImport();
                  }}
                >
                  Confirmar
                </Button>
              </Modal.Footer>
            </Modal>

        </>
    );
}
